import { produce } from 'immer';

import { MOBILE_APP_RELEASE_ACTION_TYPE } from '../actions';

const initialState = {
  config: null,
  events: [],
  iosPushCertificate: null,
};

const mobileAppReleaseReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case MOBILE_APP_RELEASE_ACTION_TYPE.GET_MOBILE_APP_RELEASE:
      case MOBILE_APP_RELEASE_ACTION_TYPE.UPDATE_MOBILE_APP_RELEASE:
      case MOBILE_APP_RELEASE_ACTION_TYPE.TURN_ON_MOBILE_APP_RELEASE:
        draft.config = payload;
        break;

      case MOBILE_APP_RELEASE_ACTION_TYPE.GET_MOBILE_APP_RELEASE_EVENTS:
        draft.events = payload;
        break;

      case MOBILE_APP_RELEASE_ACTION_TYPE.GET_IOS_PUSH_CERTIFICATE_STATUS:
        draft.iosPushCertificate = payload;
        break;

      default:
        return state;
    }
  });

export default mobileAppReleaseReducer;
